import { useState, useMemo } from "react";
import StatisticsCard from "../components/StatisticsCard";
import PowerBi from "@pages/PowerBi";
import { useHomeData } from "./useHomeData";
import { useDashboardStatistics } from "./useDashboardStatistics";

/**
 * useDashboardData Hook
 * Manages dashboard state and generates tab configurations
 * Optimized with useCallback and useMemo
 *
 * @returns {Object} Dashboard state and tab configurations
 */
export const useDashboardData = () => {
  const [activeTab, setActiveTab] = useState("secondary-sales");

  const homeData = useHomeData();
  const statistics = useDashboardStatistics(homeData);
  const { salesGroupCode } = homeData;

  // Memoized tab configuration
  const tabs = useMemo(
    () => [
      {
        key: "secondary-sales",
        label: "Secondary Sales",
        content: (
          <div>
            <PowerBi
              height="55vh"
              key={`${activeTab}-secondary-${salesGroupCode}`}
              id="19d36766-4b7d-4b15-aaa4-ed6e70c8df55"
              pageName={{
                id: "fea60e84-eaf3-48a4-90ad-795360fb0878",
                name: "Daily Sales Report",
              }}
              tableName="DimSalesHierarchy"
            />
          </div>
        ),
      },
      {
        key: "sales-operations",
        label: "Sales Operations",
        content: (
          <PowerBi
            height="55vh"
            key={`${activeTab}-salesops-${salesGroupCode}`}
            id="0165fa4f-abf5-4061-a3c4-9407106446ed"
            pageName={{
              id: "29546b7646e42d34609d",
              name: "Daily Sales Operations",
            }}
            tableName="VW_SH2Master"
          />
        ),
      },
      {
        key: "team",
        label: "Team",
        content: (
          <div className="space-y-3 p-2">
            {statistics.teamStats.map((stat, index) => (
              <StatisticsCard key={index} {...stat} />
            ))}
          </div>
        ),
      },
      {
        key: "wss",
        label: "WSS",
        content: (
          <div className="space-y-3 p-2">
            {statistics.wssStats.map((stat, index) => (
              <StatisticsCard key={index} {...stat} />
            ))}
          </div>
        ),
      },
    ],
    [activeTab, salesGroupCode, statistics.teamStats, statistics.wssStats],
  );

  return {
    activeTab,
    setActiveTab,
    tabs,
    statistics,
    salesGroupCode,
  };
};
